import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
  getHbPointData,
  submitReferalCode,
} from 'hb-redux-store/feature/halalboxPoints/hbPoint.action';
import { setAppNotification } from 'hb-redux-store/initial.action';
import {
  RUPEE_SYMBOL,
  DEVICE_TYPE,
  DEFAULT_REFERRAL_AMOUNT,
} from 'hb-redux-store/util/constantServices';
import {
  copyPlainStringToClipboard,
  shareContent,
} from 'hb-redux-store/util/miscellaneousServices';
import history from 'hb-redux-store/history';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import { showEarningHistoryModal } from 'hb-redux-store/feature/modal/modal.action';

import SecondaryNav from 'components/mweb/SecondaryNav/SecondaryNav';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import Button from 'components/common/Button/Button';
import BenefitsPoint from 'components/mweb/HalalboxPoints/BenefitsPoint';
import EarnPoint from 'components/mweb/HalalboxPoints/EarnPoint';
import Input from 'components/mweb/Input/Input';
import ReferralCode from 'components/mweb/ReferralCode/ReferralCode';
import Icon from 'components/mweb/Icon/Icon';
import Accordion from 'components/common/Accordion/Accordion';
import EarningHistory from './EarningHistory';

import './landing-page.scss';
import HBPointBgImage from 'assets/hb-point-bg.svg';
import DesktopHBPointBgImage from 'assets/desktop-hb-point-bg.svg';
import AnalyticsService from 'AnalyticsService';

const { clevertap } = AnalyticsService;

// CONSTANT
const TITLE = 'VXL Points';
const AVAILABLE_POINTS = `Available VXL Points`;
const EAT_MORE = 'Eat More with';
const VIEW_EARNING_HISTORY_CTA = 'View Earning history';
const BENEFITS_TITLE = 'Benefits of VXL Points';
const HOW_TO_EARN_TEXT = 'How to earn VXL Points';
const SUBMIT_TEXT = 'SUBMIT';
const COPY_CODE_TEXT = 'COPY CODE';
const INVITE_WITH = 'Invite with';
const ENTER_REFERRAL_CODE = 'Enter Referral Code';
const FAQ_TITLE = 'Frequently Asked Questions';
const USE_HB_POINTS = 'Use VXL Points';
const ENTER_REFERAL_CODE = 'Please Enter Referal Code';
const BLACK_COLOR = '#000';

export const RenderFaq = ({
  faq = [],
  color = BLACK_COLOR,
  blackIcon = true,
}) => {
  return (
    <>
      {faq.map((item, index) => {
        return (
          <Accordion
            key={item?.question + index}
            title={item?.question}
            content={item?.answer}
            color={color}
            blackIcon={blackIcon}
          />
        );
      })}
    </>
  );
};

const LandingPage = ({
  getHbPointData,
  referralGuides,
  hbPointData = {},
  loading = false,
  launchInfo,
  setAppNotification,
  submitReferalCode,
  showEarningHistoryModal,
}) => {
  const {
    hbPointsBalance: balancePoint,
    referred = true,
    hbPointsTitle = TITLE,
  } = hbPointData || {};
  const isHbPointBalance = balancePoint > 0;
  const hbPointBalance = balancePoint;
  const { referralShortLink, referralCode = '', customerType } = launchInfo;
  const [refCode, setRefCode] = useState(null);
  const isMobileDevice = getDeviceType() === DEVICE_TYPE.MWEB;

  useEffect(() => {
    const key = 'View HB Points page';
    const payload = {
      source: 'VXL Point',
      customerType,
    };
    clevertap.sendCleverTapEvent(key, payload);
  }, []);

  useEffect(() => {
    getHbPointData();
    return () => {};
  }, []);

  const ViewHistoryButton = () => {
    return (
      <Button
        className="button button-ghost full-width large"
        onClick={() => {
          const key = 'View Earning History';
          const payload = {
            source: 'VXL Point',
            customerType,
          };
          clevertap.sendCleverTapEvent(key, payload);
          isMobileDevice
            ? history.push('/my/vxl-point/earn-history')
            : showEarningHistoryModal(true);
        }}
      >
        {VIEW_EARNING_HISTORY_CTA}
      </Button>
    );
  };

  const RenderBenefitsData = ({ benefits = [] }) => {
    return (
      <>
        {benefits.map(item => {
          return (
            <BenefitsPoint
              key={item?.heading}
              imageUrl={item?.image}
              heading={item?.heading}
              description={item?.description}
            />
          );
        })}
      </>
    );
  };

  const RenderHowToEarn = ({ howToEarn = [] }) => {
    return (
      <>
        {howToEarn.map((item, index) => {
          return (
            <React.Fragment key={index}>
              {!isMobileDevice && item?.isReferral ? (
                <DesktopReferAndEarn item={item} />
              ) : (
                <EarnPoint
                  imageUrl={item?.image}
                  heading={item?.heading}
                  description={item?.description}
                >
                  {item?.isReferral && referralCode && <ReferAndEarn />}
                </EarnPoint>
              )}
            </React.Fragment>
          );
        })}
      </>
    );
  };

  const getTextForSharing = () => {
    const header = '*Refer and earn*';
    const {
      refereeRewardAmount: iGet = DEFAULT_REFERRAL_AMOUNT,
      referrerRewardAmount: myFriendsGet = DEFAULT_REFERRAL_AMOUNT,
    } = launchInfo || {};
    const body =
      iGet === myFriendsGet
        ? `You and your friend get ₹${iGet} each on your successful referral`
        : `You get ₹${iGet} and your friend get ₹${myFriendsGet} on your successful referral`;
    const footer = ``;
    const shareUrl = `${header}\n\n${body}\n\n${referralShortLink}\n${footer}`;
    return shareUrl;
  };

  const shareOnWhatsApp = item => {
    const payload = {
      type: item?.type,
      source: 'VXL Point',
      customerType,
    };
    clevertap.sendCleverTapEvent(item?.key, payload);

    const shareUrl = getTextForSharing();
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURI(shareUrl)}`,
      '_blank'
    );
  };

  const shareSMS = item => {
    const payload = {
      type: item?.type,
      source: 'VXL Point',
      customerType,
    };
    clevertap.sendCleverTapEvent(item?.key, payload);
    const shareUrl = getTextForSharing();
    window.open(`sms:;?body=${encodeURI(shareUrl)}`, '_blank');
  };

  const openShareIntent = item => {
    const payload = {
      type: item?.type,
      source: 'VXL Point',
      customerType,
    };
    clevertap.sendCleverTapEvent(item?.key, payload);
    const url = referralShortLink;
    const text = getTextForSharing();
    const title = 'Refer and earn';
    shareContent({ url, text, title })
      .then(({ message = null }) => {
        if (message) setAppNotification(message);
      })
      .catch(({ message }) => {
        if (message) setAppNotification(message);
      });
  };

  const shareApps = [
    {
      icon: 'icon-referral-whatsapp',
      name: 'Whatsapp',
      onClick: shareOnWhatsApp,
      key: 'Share Refer Link',
      type: 'Whatsapp',
    },
    {
      icon: 'icon-referral-fb-messenger',
      name: 'Messenger',
      onClick: openShareIntent,
      key: 'Share Refer Link',
      type: 'Messenger',
    },
    {
      icon: 'icon-referral-sms',
      name: 'SMS',
      onClick: shareSMS,
      disableInDesktop: !isMobileDevice,
      key: 'Share Refer Link',
      type: 'SMS',
    },
    {
      icon: 'icon-referral-fb',
      name: 'facebook',
      onClick: openShareIntent,
      key: 'Share Refer Link',
      type: 'Facebook',
    },
  ];

  const copyCode = text => {
    copyPlainStringToClipboard(text)
      .then(({ message }) => setAppNotification(message))
      .catch(({ message }) => setAppNotification(message));
  };

  const submitReferal = () => {
    if (!refCode) {
      return setAppNotification(ENTER_REFERAL_CODE);
    }
    const key = 'Submit Referral Code';
    const payload = {
      source: 'VXL Point',
      customerType,
      referralCode: refCode,
    };
    clevertap.sendCleverTapEvent(key, payload);
    submitReferalCode({ refCode }, res => {
      setAppNotification(res);
    });
  };

  const DesktopReferAndEarn = ({ item }) => (
    <div className="landing-page--desktop-refer-and-earn-main-container">
      <div className="landing-page--desktop-refer-and-earn-container">
        <div className="landing-page--desktop-info-container">
          <div className="landing-page--destkop-icon">
            <img src={item?.image} className="landing-page--img" />
          </div>
          <div className="landing-page--desktop-info landing-page--colmn-alignment">
            <div className="landing-page--colmn-alignment">
              <span className="landing-page--desktop-info-heading">
                {item?.heading}
              </span>
              <span className="landing-page--desktop-info-descriptio">
                {item?.description}
              </span>
            </div>
            <div className="landing-page--desktop-input">
              <InputContainer />
            </div>
          </div>
        </div>
        <div className="landing-page--desktop-refer-code-container">
          <ReferCodeContainer />
          <ReferralLink />
        </div>
      </div>
      <HowReferralWorksContainer />
    </div>
  );

  const ReferralLink = () => {
    return (
      <>
        {launchInfo?.referralShortLink && (
          <div className="landing-page--refer-link-container">
            <div className="landing-page--copy-link-container">
              <span className="landing-page--heading">Referral Link:</span>
              <Button
                className="button action-link referral--code--content--copy-cta"
                onClick={() => {
                  const key = 'Copy Referral Link';
                  const payload = {
                    source: 'VXL Point',
                    customerType,
                  };
                  clevertap.sendCleverTapEvent(key, payload);
                  copyCode(launchInfo?.referralShortLink);
                }}
              >
                <Icon
                  size={22}
                  class="icon-referral-copy referral--code--content--copy-cta-icon"
                />
                COPY LINK
              </Button>
            </div>
            <div className="landing-page--refer-link">
              {launchInfo?.referralShortLink}
            </div>
          </div>
        )}
      </>
    );
  };

  const ReferCodeContainer = () => (
    <>
      <div className="landing-page--refer-and-earn-container">
        <ReferralCode code={referralCode} width="130" height="47" />
        <Button
          className="button action-link referral--code--content--copy-cta"
          onClick={() => copyCode(referralCode)}
        >
          <Icon
            size={22}
            class="icon-referral-copy referral--code--content--copy-cta-icon"
          />
          {COPY_CODE_TEXT}
        </Button>
      </div>
      {isMobileDevice && <ReferralLink />}
      <div className="landing-page--section-divider"></div>
      <div className="landing-page--referral--share">
        <div className="landing-page--invite-title ">{INVITE_WITH}</div>
        <div className="landing-page--share-icon-container">
          {shareApps.map(
            (app, index) =>
              !app.disableInDesktop && (
                <div className="" key={index} onClick={() => app.onClick(app)}>
                  <Icon class={`app-icon ${app.icon}`} size={30} />
                </div>
              )
          )}
        </div>
      </div>
    </>
  );

  const InputContainer = () => (
    <>
      {!referred && (
        <div className="landing-page--referral-code-input-container">
          <Input
            className="landing-page--referal-code-input-box"
            type={'text'}
            placeholder={ENTER_REFERRAL_CODE}
            onChange={({ refCode }) => setRefCode(refCode)}
            value={refCode}
            name="refCode"
            maxLength={6}
            autoFocus={false}
          />
          <Button className="landing-page--submit-text" onClick={submitReferal}>
            {SUBMIT_TEXT}
          </Button>
        </div>
      )}
    </>
  );

  const HowReferralWorksContainer = () => {
    if (referralGuides?.length) {
      const getReferralContent = () =>
        referralGuides?.map((note, index) => (
          <div className="referral-guidelines--item" key={index}>
            <div className="referral-guidelines--item--disc" />
            <div>{note}</div>
          </div>
        ));
      return (
        <div className="referral-guidelines">
          <Accordion
            title="How referral works"
            content={getReferralContent()}
            color={BLACK_COLOR}
            blackIcon
          />
        </div>
      );
    }
    return false;
  };

  const ReferAndEarn = () => {
    return (
      <div className="landing-page--referal-container">
        <InputContainer />
        <ReferCodeContainer />
        <HowReferralWorksContainer />
      </div>
    );
  };
  return (
    <div className="landing-page">
      {isMobileDevice && (
        <SecondaryNav
          title={TITLE}
          capitalize
          showCart={false}
          showSearch={false}
        />
      )}
      {!isMobileDevice && <EarningHistory />}
      {loading && <Loader />}
      {isMobileDevice ? (
        <div className="landing-page--image-contaner">
          <img className="landing-page--img" src={HBPointBgImage} />
          <div className="landing-page--text-container">
            <span className="landing-page--text-container--main-text">
              {isHbPointBalance ? hbPointsTitle : EAT_MORE}
            </span>
            <div className="landing-page--text-container--sub-text-container ">
              <span className="landing-page--text-container--sub-text">
                {isHbPointBalance ? hbPointBalance : TITLE}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="landing-page--image-contaner">
          <img className="landing-page--img" src={DesktopHBPointBgImage} />
          <div className="landing-page--text-container">
            <span className="landing-page--text-container--main-text">
              {isHbPointBalance ? hbPointsTitle : EAT_MORE}
            </span>
            <div className="landing-page--text-container--sub-text-container">
              <span className="landing-page--text-container--sub-text">
                {isHbPointBalance ? hbPointBalance : TITLE}
              </span>
            </div>
            {hbPointData?.pointsHistory && (
              <div className="landing-page--button-container">
                <ViewHistoryButton />
              </div>
            )}
          </div>
        </div>
      )}
      <div className="landing-page--benifits-container">
        <div className="landing-page--earn-history-container">
          {hbPointData?.pointsHistory && isMobileDevice && (
            <ViewHistoryButton />
          )}
        </div>
        <span className="landing-page--heading-text">{BENEFITS_TITLE}</span>
        <div className="landing-page--benifits-sub-container">
          <RenderBenefitsData benefits={hbPointData?.benefits} />
        </div>
      </div>
      <div className="landing-page--earn-container">
        <span className="landing-page--heading-text">{HOW_TO_EARN_TEXT}</span>
        <RenderHowToEarn howToEarn={hbPointData?.howToEarn} />
      </div>
      <div className="landing-page--faq-container">
        <span className="landing-page--heading-text landing-page--faq-horizontal-padding">
          {FAQ_TITLE}
        </span>
        <div className={isHbPointBalance ? 'landing-page--faq-bottom' : {}}>
          <RenderFaq faq={hbPointData?.faq} />
        </div>
      </div>
      {isHbPointBalance && (
        <div className="landing-page--bottom-cta-container">
          <Button
            className="button button-primary full-width large"
            onClick={() => history.push('/')}
          >
            {USE_HB_POINTS}
          </Button>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ initialReducer, hbPointReducer, modalReducer }) => ({
  hbPointData: hbPointReducer.hbPointData,
  referralGuides: hbPointReducer.referralGuides,
  loading: hbPointReducer.loading,
  launchInfo: initialReducer.launchInfo || {},
  earningHistoryModal: modalReducer.earningHistoryModal,
});

const mapDispatchToProps = {
  getHbPointData,
  setAppNotification,
  submitReferalCode,
  showEarningHistoryModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
